import { useElement } from "../../useElement-D-RjrGa4.js";
import { useEffect, useState } from "react";
//#region src/hooks/useScrollbarPosition.ts
const calcPosition = ({ scrollHeight, clientHeight, scrollTop }) => {
	if (scrollHeight <= clientHeight) return "none";
	if (scrollTop === 0) return "top";
	if (scrollTop + clientHeight >= scrollHeight - 1) return "bottom";
	return "middle";
};
const useScrollbarPosition = () => {
	const [element, setElement] = useElement();
	const [scrollbarPosition, setPosition] = useState("none");
	useEffect(() => {
		if (element === null) return;
		const updatePosition = () => {
			if (element === null) return;
			const position = calcPosition({
				scrollHeight: element.scrollHeight,
				clientHeight: element.clientHeight,
				scrollTop: element.scrollTop
			});
			setPosition(position);
		};
		const rafId = requestAnimationFrame(updatePosition);
		element.addEventListener("scroll", updatePosition);
		const resizeObserver = new ResizeObserver(updatePosition);
		resizeObserver.observe(element);
		return () => {
			cancelAnimationFrame(rafId);
			element.removeEventListener("scroll", updatePosition);
			resizeObserver.disconnect();
		};
	}, [element]);
	return {
		setElement,
		isTop: scrollbarPosition === "top",
		isBottom: scrollbarPosition === "bottom",
		isMiddle: scrollbarPosition === "middle",
		isNone: scrollbarPosition === "none"
	};
};
//#endregion
export { useScrollbarPosition };

//# sourceMappingURL=useScrollbarPosition.js.map